import React from 'react';
import { Card } from 'react-bootstrap';
export function CardErrorMessage(_ref) {
  let {
    errorMessage
  } = _ref;
  return /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement("div", {
    className: "text-center text-muted"
  }, !errorMessage && /*#__PURE__*/React.createElement("h1", null, "An unknown error has occured. The erorr card component was called but no error message was provided."), /*#__PURE__*/React.createElement("h1", null, errorMessage)));
}